import React, { useState } from "react";
import styles from "./ListCard.module.css";
import clsx from "clsx";
import Paragraph, { ParagraphSize } from "../../../components/Paragraph";
import { useTranslation } from "react-i18next";
import ImageComponent from "../../../components/ImageComponent";
import VideoDialog from "./VideoDialog";
import RedirectCircleView from "../../../components/RedirectCircleView";
import IndicatorVideoImage from "../../../components/IndicatorVideoImage";
import AssetsPack from "../../../util/AssetsPack";

interface ListCardProps {
  title: string;
  description: string;
  videoUrl: string;
  indicatorIcon: string;
  posterImg: string;
  classNameStyle?: string;
}

const ListCard: React.FC<ListCardProps> = ({
  title,
  description,
  indicatorIcon,
  videoUrl,
  posterImg,
  classNameStyle,
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const redirect = false;

  return (
    <div className={clsx(styles["card-wrapper"], classNameStyle)}>
      <div className={styles.card} onClick={() => setOpen(true)}>
        <div className={styles.video_container}>
          <ImageComponent src={posterImg} className={styles["poster-view"]} />
          <div className={styles["icon-indicator"]}>
            <IndicatorVideoImage indicatorUrl={indicatorIcon} />
          </div>

          <div className={styles["play-view"]}>
            <ImageComponent src={AssetsPack.icons.PLAY_ICON.default} />
          </div>

          <div className={styles.watch_video}>
            {t("joker_learn_page.watch_video")}
          </div>
        </div>
        <div className={styles["content-wrapper"]}>
          <h3 className={styles.title}>{title}</h3>
          <div className={styles.description}>
            <Paragraph
              size={ParagraphSize.paragraph2}
              classNameStyle={styles["description-text"]}
            >
              {description}
            </Paragraph>

            {redirect && (
              <div className={styles["card-gametype-redirect"]}>
                <RedirectCircleView />
              </div>
            )}
          </div>
        </div>
      </div>

      {open && (
        <VideoDialog
          videoUrl={videoUrl}
          isOpen={open}
          title={title}
          onClose={() => setOpen(false)}
        />
      )}
    </div>
  );
};

export default ListCard;
